
import { BaseModulePublicApi } from "../../base/BaseModulePublicApi";

export class PublicPagesApi extends BaseModulePublicApi {
  basePath = 'pages';
};
